/*
* Copyright(c) 2018. Synergy Systems & Solutions. @link : http://s3india.com 
*
* @module : GiftService
* @file : GiftService.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of GiftService
*
* Created on : 11-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 19-Oct-2019
*/
import axios from 'axios';
const API_URL = 'https://quiz.wanitsch.ch/quiz/quiz_app.php';

class GiftService
{
	async getAllGift()
	{
		const url = `${API_URL}`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		let session_id = sessionStorage.getItem('session_id');
		let formData  = new FormData();
		formData.append('token','');
		formData.append('command','get_gifts');
		formData.append('session_id',session_id);
		return axios({
			url:url,
			method: 'post',
			data: formData,
			config:{headers:headers}
		}).then(function(response) {
			return response.data;
		}).catch(function(response) {
			return response;
		});
	}

	async addGift(gift_id)
	{
		const url = `${API_URL}`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		let session_id = sessionStorage.getItem('session_id');
		let formData  = new FormData();
		formData.append('token','');
		formData.append('command','add_gift');
		formData.append('session_id',session_id);
		formData.append('gift_id',gift_id);
		return axios({
			url:url,
			method: 'post',
			data: formData,
			config:{headers:headers}
		}).then(function(response) {
			return response.data;
		}).catch(function(response) {
			return response;
		});
	}

	async getUserGift()
	{
		const url = `${API_URL}`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		let session_id = sessionStorage.getItem('session_id');
		let formData  = new FormData();
		formData.append('token','');
		formData.append('command','fetch_user_gift');
		formData.append('session_id',session_id);
		return axios({
			url:url,
			method: 'post',
			data: formData,
			config:{headers:headers}
		}).then(function(response) {
			return response.data;
		}).catch(function(response) {
			return response;
		});
	}
}

export default GiftService;

